/* Publish by EComposer at 2025-07-30 09:01:37*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jysxagbud8f"]=  window.__ectimmers["ecom-jysxagbud8f"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-jysxagbud8f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jysxagbud8f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okexwv4z92l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okexwv4z92l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-up4u38ydzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-up4u38ydzu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b6y5t5l5iff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b6y5t5l5iff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p5oruhg7vb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p5oruhg7vb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gn671pp5qtt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gn671pp5qtt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yymkj4yrgzb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yymkj4yrgzb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhbljbownud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhbljbownud', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vquk70v5e89"]=  window.__ectimmers["ecom-vquk70v5e89"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-vquk70v5e89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vquk70v5e89', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdtuixn1mnq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdtuixn1mnq', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d5e03i1h9fh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5e03i1h9fh', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rw7kbadowh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rw7kbadowh', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ioaf1wg9dwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ioaf1wg9dwa', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5bzh9bllq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5bzh9bllq', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cn0u6x8ungq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cn0u6x8ungq', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iaz0ffgyt0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iaz0ffgyt0h', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghb3smwyle').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghb3smwyle', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}